<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2023-08-31 11:12:21
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-11-08 10:54:23
 * @FilePath: \official_website\src\views\products\details\Dna.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- DNA定量分析系统  -->
<template>
  <div id="dnaProd">
    <Header></Header>
    <div class="dnaProd-conter">
      <div class="dnaProd-img">
        <Breadcrumb
          :productType="productType"
          :productName="productName"
        ></Breadcrumb>
        <!-- <img src="@/assets/image/product-detail/programme-3.png" alt="" /> -->
        <div class="illustrate-box">
          <div class="title wow animate__animated animate__fadeInUp">
            DNA定量分析系统
          </div>
          <div class="line"></div>
          <ul class="keywords wow animate__animated animate__fadeInUp">
            <li>快速</li>
            <li>简洁</li>
            <li>精准</li>
            <li>高效</li>
          </ul>
        </div>
      </div>
      <div class="dnaProd-description">
        <div class="parameter">
          <img
            class="wow animate__animated animate__fadeInUp"
            src="@/assets/image/dnaProd/parameter.png"
            alt="产品参数"
          />
        </div>
        <div class="characteristic">
          <ul class="feature-box">
            <li class="feature-item">
              <div class="left">
                <img
                  class="wow animate__animated animate__fadeInUp"
                  src="@/assets/image/dnaProd/icon-1.png"
                  alt="染色全"
                />
              </div>
              <div class="right wow animate__animated animate__fadeInUp">
                <div class="title">染色全</div>
                <div class="desc">
                  一片双染，一个样本、一张玻片、一次扫描、两张（DNA+TCT）报告
                </div>
              </div>
            </li>
            <li class="feature-item">
              <div class="left">
                <img
                  class="wow animate__animated animate__fadeInUp"
                  src="@/assets/image/dnaProd/icon-1.png"
                  alt="效率高"
                />
              </div>
              <div class="right wow animate__animated animate__fadeInUp">
                <div class="title">效率高</div>
                <div class="desc">
                  DNA染色最快仅需15分钟，扫描+识别时间≤2分钟
                </div>
              </div>
            </li>
            <li class="feature-item">
              <div class="left">
                <img
                  class="wow animate__animated animate__fadeInUp"
                  src="@/assets/image/dnaProd/icon-1.png"
                  alt="检出准"
                />
              </div>
              <div class="right wow animate__animated animate__fadeInUp">
                <div class="title">检出准</div>
                <div class="desc">
                  全片扫描、全片识别，充分发现每一个异常细胞。
                </div>
              </div>
            </li>
            <li class="feature-item">
              <div class="left">
                <img
                  class="wow animate__animated animate__fadeInUp"
                  src="@/assets/image/dnaProd/icon-1.png"
                  alt="警示早"
                />
              </div>
              <div class="right wow animate__animated animate__fadeInUp">
                <div class="title">警示早</div>
                <div class="desc">相比细胞形态学更早发现癌前病变</div>
              </div>
            </li>
            <li class="feature-item">
              <div class="left">
                <img
                  class="wow animate__animated animate__fadeInUp"
                  src="@/assets/image/dnaProd/icon-1.png"
                  alt="应用广"
                />
              </div>
              <div class="right wow animate__animated animate__fadeInUp">
                <div class="title">应用广</div>
                <div class="desc">
                  可用于宫颈癌、口腔癌、肺癌等肿瘤疾病的早期筛查。
                </div>
              </div>
            </li>

            <li class="feature-item">
              <div class="left">
                <img
                  class="wow animate__animated animate__fadeInUp"
                  src="@/assets/image/dnaProd/icon-1.png"
                  alt="开展易"
                />
              </div>
              <div class="right wow animate__animated animate__fadeInUp">
                <div class="title">开展易</div>
                <div class="desc">
                  对阅片专业要求相对较低，非常适合基层医院开展。
                </div>
              </div>
            </li>
            <li class="feature-item">
              <div class="left">
                <img
                  class="wow animate__animated animate__fadeInUp"
                  src="@/assets/image/dnaProd/icon-1.png"
                  alt="结果全"
                />
              </div>
              <div class="right wow animate__animated animate__fadeInUp">
                <div class="title">结果全</div>
                <div class="desc">
                  一片双染，一次采样，一次检测，可提供TCT+DNA两份报告。
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <RelatedProduct :swiperData="relatProd"></RelatedProduct>
    </div>
    <div class="footer">
      <Footer></Footer>
    </div>
  </div>
</template>
    
<script>
import Header from "@/views/componets/Header.vue";
import Footer from "@/views/componets/Footer.vue";
import RelatedProduct from "../componets/RelatedProduct.vue";
import Breadcrumb from "@/views/componets/Breadcrumb.vue";
import api from "../../../api/api";

export default {
  name: "",
  props: {},
  components: {
    Header,
    Footer,
    RelatedProduct,
    Breadcrumb,
  },
  data() {
    return {
      productType: "产品",
      productName: "DNA定量分析系统",
      relatProd: [
        {
          title: "全自动特殊染色机",
          src: require("@/assets/image/product/film-4.png"),
          path: "/product/special",
        },
        {
          title: "DNA定量分析诊断试剂",
          src: require("@/assets/image/product/reagent-2.png"),
          path: "/product/dnaReagent",
        },
        {
          title: "扫描通量600片",
          src: require("@/assets/image/product/digit-1.png"),
          path: "/product/gemini",
        },
        {
          title: "扫描通量120片",
          src: require("@/assets/image/product/digit-2.png"),
          path: "/product/gemini",
        },
        {
          title: "扫描通量30片",
          src: require("@/assets/image/product/digit-3.png"),
          path: "/product/gemini",
        },
        {
          title: "扫描通量2片",
          src: require("@/assets/image/product/digit-4.png"),
          path: "/product/gemini",
        },
      ],
      urlPath: "", // 当前路由
      allProdList: [], // 所有产品数据
      currentList: {}, // 当前页面数据
    };
  },
  async created() {
    await this.getPordList(1, 100, {});
    await this.getChooseId(this.currentList.id);
  },
  mounted() {
    this.$nextTick(() => {
      new this.$wow.WOW({
        boxClass: "wow", // 动画元件css类（默认为wow）
        animateClass: "animate__animated", //动画css类（默认为animated）
        offset: 0, //到元素距离触发动画（当默认为0）
        mobile: true, //在移动设备上触发动画（默认为true）
        live: true, //对异步加载的内容进行操作（默认为true）
      }).init();
    });
  },
  watch: {
    $route: {
      // $route可以用引号，也可以不用引号  监听的对象
      handler(to, from) {
        // console.log(to.path);
        this.urlPath = to.path;
      },
      deep: true, // 深度观察监听 设置为 true
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  },
  methods: {
    // 获取所有产品信息
    async getPordList(pageIndex, pageSize, params) {
      try {
        var res = await api.getPorductList(pageIndex, pageSize, params);
        if (res && res.data && res.data.code === 200) {
          this.allProdList = res.data.models;
          let presentProd = this.allProdList.filter((item) => {
            return item.summary == this.urlPath;
          });
          this.currentList = presentProd.length != 0 ? presentProd[0] : 0;
        } else {
        }
      } catch (error) {}
    },
    // 获取相关产品信息
    async getChooseId(prodId) {
      try {
        var res = await api.getProdRelationByid(prodId);
        if (res && res.data && res.data.code === 200) {
          if (res.data.models) {
            let result = res.data.models[0].relationID;
            if (result) {
              let relationArr = result.split(",");
              let tepmArr = [];
              relationArr.forEach((item) => {
                tepmArr.push(Number(item));
              });

              let relatedList = [];
              tepmArr.forEach((items) => {
                let secData = this.allProdList.filter((item) => {
                  return item.id == items;
                });
                if (secData.length != 0) {
                  relatedList.push(secData[0]);
                }
              });

              this.relatProd = relatedList;
            } else {
            }
          }
        } else {
        }
      } catch (error) {}
    },
  },
};
</script>
    
<style lang="scss">
#dnaProd {
  width: 100%;
  height: 100%;
  .dnaProd-conter {
    padding-top: 5rem;
    .dnaProd-img {
      position: relative;
      height: 50rem;
      background-image: url("../../../assets/image/product-detail/programme-3.png");
      background-size: cover;
      // img {
      //   width: 100%;
      // }
      .illustrate-box {
        position: absolute;
        left: 18%;
        top: 30%;
        width: 21.875rem;
        .title {
          font-size: 1.8rem;
          font-family: "SourceHanSansSC-Medium";
          margin-bottom: 2.8125rem;
        }
        .line {
          width: 4.25rem;
          height: 3px;
          margin-bottom: 1.25rem;
          background: #177a73;
        }
        .keywords {
          display: flex;
          li {
            width: 22%;
            height: 2.1875rem;
            line-height: 2.1875rem;
            margin-right: 4%;
            color: #fff;
            background: #177a73;
            border-radius: 2.1875rem;
            text-align: center;
            &:last-of-type {
              margin-right: 0;
            }
          }
        }
      }
    }
    .dnaProd-description {
      width: 100%;
      padding: 3.75rem 15%;
      .parameter {
        width: 100%;
        margin: 2rem 0 5rem;
        img {
          display: block;
          width: 90%;
          margin: auto;
        }
      }
      .characteristic {
        width: 90%;
        margin: auto;
        .feature-box {
          display: flex;
          flex-wrap: wrap;
          .feature-item {
            display: flex;
            align-items: center;
            width: 48%;
            margin-bottom: 2rem;
            margin-right: 4%;
            &:nth-of-type(2n) {
              margin-right: 0;
            }
            .left {
              width: 10%;
              margin-right: 1.2rem;
              img {
                width: 100%;
              }
            }
            .right {
              .title {
                font-size: 1.4rem;
                font-family: "SourceHanSansSC-Medium";
                margin-bottom: 1rem;
              }
              .desc {
                font-size: 1rem;
                font-family: "OPlusSans3-Regular";
              }
            }
          }
        }
      }
    }
  }
  .footer {
    width: 100%;
    height: 100%;
    background: #f5f5f5;
    padding: 6.25rem 8% 3.125rem;
  }
}
</style>